// eslint-disable-line no-unused-expressions
import React from "react";
import ExeIcon from "../../../Icon-SVG/ExeIcon";
import InfoTable, { InfoRow } from "../InfoTable/InfoTable";

// Picks the largest unit that keeps the number readable, so a report shows
// "1.20 MB" instead of a seven digit byte count.
const readableSize = (bytes) => {
  const value = Number(bytes);

  if (!Number.isFinite(value) || value < 0) return null;

  const units = ["B", "KB", "MB", "GB", "TB"];
  let unitIndex = 0;
  let size = value;

  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex += 1;
  }

  return `${unitIndex === 0 ? size : size.toFixed(2)} ${units[unitIndex]}`;
};

/*report: this variable belongs to the pdf page */
const GeneralInformationCard = ({
  fileName,
  size,
  sha1,
  started,
  reportDate,
  fileID,
  linkDisabled,
  setShowPopup,
  displayViewRelated = true,
}) => {
  let listTypeTags = "";
  let listNetworkTags = "";
  let machine = "";
  listTypeTags = fileID.includes("full_triage") ? "Full Triage" : "";
  listTypeTags = fileID.includes("high_evasion") ? "High Evasion" : listTypeTags;
  listTypeTags = fileID.includes("basic_evasion") ? "Basic Evasion" : listTypeTags;
  listNetworkTags = fileID.includes("internet") ? "Internet" : "";
  listNetworkTags = fileID.includes("vpn") ? "Vpn" : listNetworkTags;
  listNetworkTags = fileID.includes("simulate") ? "Simulate" : listNetworkTags;
  listNetworkTags = fileID.includes("disable") ? "Disable" : listNetworkTags;
  machine = fileID.includes("win7")
    ? "Windows 7 x64"
    : fileID.includes("win10")
      ? "Windows 10 x64"
      : fileID.includes("win11")
        ? "Windows 11 x64"
        : fileID.includes("linux22")
          ? "Linux x64"
          : fileID.includes("macos16")
            ? "MacOS 16"
            : fileID.includes("andro13")
              ? "Android 13"
              : "";

  const reportDateObj = new Date(reportDate);
  const validReportDate = !Number.isNaN(reportDateObj.getTime());
  const formattedDate = validReportDate
    ? reportDateObj.toLocaleDateString("zh-TW").replace(/\./g, "/")
    : "";
  const formattedTime = validReportDate
    ? reportDateObj.toLocaleTimeString("zh-TW", { hour12: false })
    : "";

  const exactBytes = Number.isFinite(Number(size)) ? Number(size).toLocaleString("en-US") : null;
  const fileSize = readableSize(size);

  return (
    <div className=" analysis-reports__body-block__information border">
      <h3 className="article">General Information</h3>
      <div className="analysis-reports__body-block__information-exe">
        <ExeIcon width={16} height={16} />
        <span title={fileName}>{fileName}</span>
      </div>

      <InfoTable>
        <InfoRow
          label="File Size"
          value={
            fileSize ? (
              <>
                {fileSize}
                {exactBytes ? (
                  <span className="general-info__hint">({exactBytes} bytes)</span>
                ) : null}
              </>
            ) : null
          }
          title={exactBytes ? `${exactBytes} bytes` : undefined}
        />
        <InfoRow label="SHA256" value={sha1} mono={true} copyable={true} />
        <InfoRow label="Submission Date" value={started} />
        <InfoRow
          label="Report Date"
          value={validReportDate ? `${formattedDate} (${formattedTime})` : null}
        />
        <InfoRow label="Operating System" value={machine} />
        <InfoRow label="Network Traffic" value={listNetworkTags} />
        <InfoRow label="Analysis Type" value={listTypeTags} />
      </InfoTable>

      {displayViewRelated ? (
        <span className="analysis-reports__body-block__information__view-related">
          <button
            onClick={() => setShowPopup(true)}
            className="analysis-reports__body-block__information__button"
            disabled={linkDisabled}>
            View Related
          </button>
        </span>
      ) : null}
    </div>
  );
};

export default GeneralInformationCard;
